import { createAsyncThunk } from '@reduxjs/toolkit';
import { connectApi } from '@app/api';

export const unassignEmployee = createAsyncThunk<any, any>(
  'employee/unassign',
  async ({ companyId, userId }, { dispatch }) => {
    return (await connectApi.employee.unassign(companyId, userId))?.data
      ?.payload;
  }
);
